import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ReportViewer from '../components/ReportViewer';
import ReportAdLayout, { MobileReportAd } from '../components/ReportAdLayout';

function CopyUrlButton() {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <button className="lb-btn lb-btn-outline" style={{ minHeight: '36px', padding: '0 14px', fontSize: '14px' }} onClick={handleCopy}>
      {copied ? '✓ 복사됨!' : '🔗 URL 복사'}
    </button>
  );
}

export default function ReportPage() {
  const { reportId } = useParams();
  const [status,   setStatus]   = React.useState('loading');
  const [errorMsg, setErrorMsg] = React.useState('');
  const [data,     setData]     = React.useState(null);

  React.useEffect(() => {
    // Token is in the URL fragment (#token=...) — never sent to server by the browser
    const hash = window.location.hash.slice(1);
    const token = new URLSearchParams(hash).get('token');

    if (!token) {
      setErrorMsg('리포트 접근 토큰이 없습니다. 리포트 생성 시 받은 URL을 사용해 주세요.');
      setStatus('error');
      return;
    }

    fetch(`/api/reports/${reportId}`, {
      headers: { 'Authorization': `Bearer ${token}` },
    })
      .then(res => {
        if (res.status === 401) throw new Error('유효하지 않은 접근 토큰입니다.');
        if (res.status === 404) throw new Error('리포트를 찾을 수 없거나 만료되었습니다.');
        if (!res.ok) throw new Error(`서버 오류 (${res.status})`);
        return res.json();
      })
      .then(json => {
        setData(json);
        setStatus('ready');
      })
      .catch(err => {
        setErrorMsg(err.message);
        setStatus('error');
      });
  }, [reportId]);

  if (status === 'loading') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '16px' }}>
        <div className="lb-spinner" />
        <p style={{ color: 'var(--color-text-muted)', fontSize: '15px' }}>리포트를 불러오는 중...</p>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div className="lb-card lb-card-padded" style={{ maxWidth: '420px', textAlign: 'center' }}>
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>⚠️</div>
          <div className="lb-alert lb-alert-error">{errorMsg}</div>
          <Link to="/" className="lb-btn lb-btn-outline" style={{ marginTop: '16px', display: 'inline-flex' }}>
            ← 처음으로
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* 툴바 — 인쇄 시 숨김 */}
      <div
        className="d-print-none"
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 50,
          background: 'rgba(255,250,243,0.92)',
          backdropFilter: 'blur(14px)',
          borderBottom: '1px solid var(--color-border-light)',
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '10px',
          flexWrap: 'wrap',
        }}
      >
        <a className="lb-logo" href="/" style={{ fontSize: '18px' }}>☕ 라떼비버</a>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <CopyUrlButton />
          <a
            className="lb-btn lb-btn-outline"
            href="https://comm.beaver-pension.com/?source=report&utm_source=report&utm_medium=cta"
            style={{ minHeight: '36px', padding: '0 14px', fontSize: '14px' }}
          >
            연금 질문하기
          </a>
          <button
            className="lb-btn lb-btn-outline"
            style={{ minHeight: '36px', padding: '0 14px', fontSize: '14px' }}
            onClick={() => window.print()}
          >
            🖨 인쇄 / PDF
          </button>
          <Link
            to="/"
            className="lb-btn lb-btn-primary"
            style={{ minHeight: '36px', padding: '0 14px', fontSize: '14px' }}
          >
            + 새 리포트
          </Link>
        </div>
      </div>

      <ReportAdLayout>
        <MobileReportAd className="report-view-mobile-ad" />
        <ReportViewer
          customer={data.input}
          reportId={data.reportId}
          createdAt={data.createdAt}
        />
      </ReportAdLayout>
    </div>
  );
}
